module.exports = __webpack_public_path__ + "static/media/c1.a6e22a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/c1.png
// module id = 46
// module chunks = 0